// extracted by mini-css-extract-plugin
export default {"table":"index_table_cuUFU"};